<div class="skv-box" role="main">
    <h2>Sidan kunde inte hittas</h2>
    <p>Det verkar som att sidan du letar efter är försvunnen. Vi beklagar och hoppas att dessa länkar kan hjälpa dig.
    </p>
    <app-link href="start">Ansökan om legitimation för lärare och förskollärare</app-link>
    <br />
    <app-link href="https://www.skolverket.se">Skolverkets startsida</app-link>
</div>